export default {"src":"/_next/static/media/eye_open.321bd2d2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};